'use strict';

export default [
  {
    name: 'Contact us',
    model: 'Contact',
    id: 2,
    path: 'contact',
  },
];



// WEBPACK FOOTER //
// ./client/models/global/noAuthed.js